module.exports = __webpack_public_path__ + "static/media/temp2.1a1e20cb.png";